import { ALL_VALUE } from './helper';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';

export const assigneeDefault: DropdownOption = {
  key: ALL_VALUE,
  value: ALL_VALUE,
  label: 'All users',
};

export const ASSIGNEE_ID_PARAM = 'assigneeId';

export const assigneeIdSelectedOrURLOrDefault = (
  allAssignees: DropdownOption[],
  selectedAssignee: DropdownOption | undefined
) => {
  if (selectedAssignee !== undefined) {
    return selectedAssignee;
  }

  const params = new URLSearchParams(location.search);
  const paramValue = params.get(ASSIGNEE_ID_PARAM);
  if (paramValue !== null) {
    const found = allAssignees.find((a) => a.value === paramValue);
    if (found !== undefined) {
      return found;
    }
  }

  return assigneeDefault;
};

export const assigneeIdToFetchForTransactionAlertsBacklog = (selectedAssignee: DropdownOption | undefined) => {
  if (selectedAssignee !== undefined) {
    return selectedAssignee.value === ALL_VALUE ? undefined : selectedAssignee.value;
  }

  const params = new URLSearchParams(location.search);
  const value = params.get(ASSIGNEE_ID_PARAM);
  if (value !== null && value !== ALL_VALUE) {
    return value;
  }

  return undefined;
};
